import Vue from 'vue';
import VueAuth from '@websanova/vue-auth';

import auth from "@websanova/vue-auth/drivers/auth/bearer.js";
import http from "@websanova/vue-auth/drivers/http/axios.1.x.js";
import router from "@websanova/vue-auth/drivers/router/vue-router.2.x.js";

Vue.use(VueAuth, {
  auth,
  http,
  router,
  registerData: {url: '/api/register', method: 'POST', redirect: '/'},
  loginData: {
    url: '/api/login',
    method: 'POST',
    redirect: '/',
    fetchUser: true,
  },
  logoutData: {
    url: '/api/logout',
    method: 'POST',
    redirect: '/login',
    makeRequest: true,
  },
  fetchData: {url: '/api/user', method: 'GET', enabled: true},
  refreshData: {
    url: '/api/refresh',
    method: 'POST',
    enabled: true,
    interval: 30,
    error: () => {}
  },
  rolesKey: 'role',
  parseUserData: (data) => data,
//    tokenExpired: () => {
//        return false;
//    }
});
